import { LoadingSize } from './types';

// Loading spinner size configurations
export const LOADING_SIZES: Record<LoadingSize, number> = {
  small: 24,
  medium: 40,
  large: 60
} as const;

// Animation and timing constants
export const LOADING_ANIMATION = {
  DURATION: 1400, // Material UI default duration in ms
  FADE_TIMEOUT: 300, // Backdrop fade transition
  THICKNESS: 3.6, // CircularProgress thickness
  BACKDROP_OPACITY: 0.5
} as const;

// Z-index values following Material UI standards
export const LOADING_Z_INDEX = {
  BACKDROP: 1300, // Material UI Backdrop default
  SPINNER: 1301
} as const;

// Default configuration
export const DEFAULT_LOADING_CONFIG = {
  SIZE: 'medium' as LoadingSize,
  COLOR: 'primary' as const,
  VARIANT: 'indeterminate' as const,
  THICKNESS: LOADING_ANIMATION.THICKNESS,
  DISABLE_SHRINK: false
} as const;

// Accessibility constants
export const LOADING_ARIA = {
  LABEL: 'Cargando contenido',
  LIVE_REGION: 'polite' as const,
  ROLE: 'status' as const
} as const;
